import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AddFileService } from './add-file.service';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ConboxDialogComponent } from './dialog-conbox.component';
import { consts } from '../../../consts';
import { LocalDB } from '../../utils';

@Component({
    selector: 'app-add-file',
    templateUrl: './add-file.component.html',
    styleUrls: ['./add-file.component.scss'],
    standalone: false
})
export class AddFileComponent implements OnInit {
  constructor(
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    private addFileService: AddFileService,
  ) { }

  @Output() CallbackParameters = new EventEmitter();
  // Se emite cada vez que loadingFile cambia. Un componente padre no puede
  // leer una variable de plantilla (#ref) declarada dentro de un *ngIf desde
  // fuera de ese bloque (p.ej. para deshabilitar su propio botón Guardar
  // mientras se sube el archivo) — Angular limita esas variables al bloque
  // donde se declaran. Este Output es la forma correcta de exponer el estado.
  @Output() loadingChange = new EventEmitter<boolean>();

  @Input() originEntity: string = "";
  @Input() filePath: string = "";

  @Input() imageTempUrl: any = '';

  @Input() showConvfactFiles: boolean = true;

  private _loadingFile: boolean = false;
  get loadingFile(): boolean { return this._loadingFile; }
  set loadingFile(value: boolean) {
    this._loadingFile = value;
    this.loadingChange.emit(value);
  }

  dialogRef: MatDialogRef<ConboxDialogComponent>;



  ngOnInit() {
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  public uploadPDF(event): void {
    this.imageTempUrl = null;
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.loadingFile = true;
      const file: File = fileList[0];
      const formData: FormData = new FormData();
      formData.append('file', file, file.name);

      this.addFileService.attachFile(formData, this.originEntity).then(response => {
        if (response.error) {
          this.displayInfo(response.message);
          this.loadingFile = false;
        } else {
          LocalDB.RemoveForFiles();
          this.loadingFile = false;
          // El propio fichero seleccionado ya es un Blob válido para la
          // vista previa (igual que uploadImage) — pedirlo de vuelta al
          // servidor solo re-descargaba de S3 el archivo recién subido.
          this.CallbackParameters.emit({ PDF: true, Image: false, FileUid: response.uid, File: file });
        }
      })
    }
  }

  public uploadImage(event): void {
    this.imageTempUrl = null;
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.loadingFile = true;
      const file: File = fileList[0];
      const formData: FormData = new FormData();
      formData.append('file', file, file.name);

      this.addFileService.attachFile(formData, this.originEntity).then(response => {
        if (response.error) {
          this.displayInfo(response.message);
          this.loadingFile = false;
        } else {
          LocalDB.RemoveForFiles();
          this.displayInfo('Imagen guardada correctamente');
          this.loadingFile = false;
          if (event.target.files && event.target.files[0]) {
            this.CallbackParameters.emit({ PDF: false, Image: true, FileUid: response.uid, File: event.target.files[0] });
          }
        }
      })
    }
  }

  public getFromFiles() {
    this.imageTempUrl = null;
    this.dialogRef = this.dialog.open(ConboxDialogComponent, {
      height: '80%',
      width: '80%',
      data: {
        originEntity: this.originEntity,
        filePath: this.filePath
      }
    });

    this.dialogRef.afterClosed().subscribe(result => {
      if (result != null && result.uid != null && result.uid != "") {
        this.loadingFile = true;

        let isPDF: boolean = false;
        let isImage: boolean = false;

        if (result.type === consts.TYPE_FILE_PDF) {
          isPDF = true;
          this.addFileService.getImageFromFilesPDF(result.uid, this.originEntity).then(response => {
            const data = response;
            this.loadingFile = false;
            this.CallbackParameters.emit({ PDF: isPDF, Image: isImage, FileUid: result.uid, File: data });
          });
        }

        if (result.type === consts.TYPE_FILE_IMAGE) {
          isImage = true;
          this.addFileService.getImageFromFiles(result.uid, this.originEntity).then(response => {
            const data = response;
            this.loadingFile = false;
            this.CallbackParameters.emit({ PDF: isPDF, Image: isImage, FileUid: result.uid, File: data });
          })
        }
      }
    });
  }

}
